import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaStar } from 'react-icons/fa';
import { motion } from 'framer-motion';
import { useParams } from 'react-router-dom';

const FeedbackForm = () => {
  const { id } = useParams();
  const [feedbackExists, setFeedbackExists] = useState(false);
  const [formData, setFormData] = useState({
    id: id,
    name: '',
    comment: '',
    stars: 0,
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    // Check if feedback already exists
    axios
      .get(`https://api.theinviteyou.com/api/feedback/${id}`)
      .then((response) => {
        if (response.data) {
          setFeedbackExists(true);
        }
      })
      .catch((error) => {
        console.error('Error fetching feedback:', error);
      });
  }, [id]);

  const handleSubmit = (e) => {
    e.preventDefault();

    axios
      .post('https://api.theinviteyou.com/api/sendfeedback', formData)
      .then(() => {
        setSubmitted(true);
      })
      .catch((error) => {
        console.error('Error submitting feedback:', error);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleStarClick = (stars) => {
    setFormData((prev) => ({ ...prev, stars }));
  };

  if (feedbackExists || submitted) {
    return (
      <div className="p-4 max-w-md mx-auto mt-10 bg-white rounded-lg shadow-md">
        <div className="text-center">
          <h2 className="text-xl font-bold">Terima Kasih</h2>
          <p className="text-gray-600">Kami sangat menghargai maklumbalas dari anda.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="p-4 max-w-md mx-auto mt-10 bg-white rounded-lg shadow-md">
      <div>
        <h2 className="text-xl text-center mb-4">Feedback</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Nama</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder='Masukkan nama anda'
              className="mt-1 block w-full px-3 py-2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Komen</label>
            <textarea
              name="comment"
              value={formData.comment}
              placeholder='Tinggalkan komen anda disini'
              onChange={handleChange}
              rows="4"
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
              required
            ></textarea>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Rating</label>
            <div className="flex space-x-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <motion.button
                  key={star}
                  type="button"
                  onClick={() => handleStarClick(star)}
                  whileHover={{ scale: 1.2 }}
                  className={`rounded-full p-2 ${
                    formData.stars >= star
                      ? 'text-yellow-500'
                      : 'text-gray-300'
                  }`}
                >
                  <FaStar size={24} />
                </motion.button>
              ))}
            </div>
          </div>
          <button
            type="submit"
            className="w-full bg-primary-500 hover:bg-primary-700 text-white py-2 rounded-md shadow-sm"
          >
            Submit Feedback
          </button>
        </form>
      </div>
    </div>
  );
};

export default FeedbackForm;
